import React from "react";
import { Text, View, StyleSheet, Font, Image } from "@react-pdf/renderer";
import moment from "moment";
import Jsbarcode from "jsbarcode";
import QRCode from "qrcode";
import logo_emma from "../assets/img/emma_red.png";
import logo_rnb from "../assets/img/rnb4culture.png";

// Font.register({
//   family: "Roboto",
//   src: "https://fonts.googleapis.com/css2?family=Roboto:wght@400&display=swap"
// });

Font.register({
  family: "Roboto",
  src:
    "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf",
});

Font.register({
  family: "RobotoBold",
  src:
    "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-black-webfont.ttf",
});
Font.register({
  family: "RobotoItalic",
  src:
    "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-italic-webfont.ttf",
});
// Create styles
const styles = StyleSheet.create({
  grayBox: {
    backgroundColor: "#f0f0f0",
    padding: "10px",
    /* border: 1px solid #dddddd ; */
    textAlign: "center",
    fontFamily: "Roboto",
    fontSize: "14px",
    width: "500px",
    // height: "max-content"
  },

  body: {
    color: "#111111",
    backgroundColor: "#fff",
    textAlign: "center",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  title: {
    fontSize: "18px",
    fontWeight: "800",
  },
  bold: {
    fontWeight: "800",
  },
  footerBox: {
    textAlign: "left",
    padding: "10px",
    paddingTop: "10px",
    paddingBottom: "10px",
    fontFamily: "Roboto",
    backgroundColor: "#f0f0f0",
    fontSize: "6px",
    width: "500px",
    color: "#4a4a4a",
  },
  // .footerBox a, a:focus, a:link, a:active, a:hover, a:visited  {
  //     color: inherit;
  //     background-color: transparent;
  //     text-decoration: underline;
  // }
  noreplyBox: {
    backgroundColor: "#ffffff",
    textAlign: "center",
    fontSize: "12px",
    width: "500px",
    color: "gray",
  },
  barcode: {
    maxWidth: "60%",
    width: "400px",
    margin: "0 auto",
  },
  qrcode: {
    maxWidth: "100px",
    width: "100px",
    margin: "0 auto",
  },
  break: {
    height: "10px",
    width: "100%",
  },
  break_2: {
    height: "20px",
    width: "100%",
  },
  boldText: {
    fontFamily: "RobotoBold",
  },
  italicText: {
    fontFamily: "RobotoItalic",
  },
  //
  // .noreplyBox a, a:focus, a:link, a:active, a:hover, a:visited {
  //     color:inherit;
  //     background-color: transparent;
  //     text-decoration: underline;
  // }

  poweredBy: {
    backgroundColor: "#ffffff",
  },
  logo: {
    height: 30,
    objectFit: "contain",
    margin: 10,
  },
});

export default function generateTicketHtml(
  username,
  museumName,
  telMuseo,
  emailMuseo,
  addressMuseo,
  logoMuseo,
  luogoEvento,
  data,
  oraInizio,
  oraFine,
  eventName,
  infoEvento,
  numPartecipanti,
  typeTicket,
  price,
  paymentMethod,
  code
) {
  // const a = <Barcode value={code} background="#000" />;
  // TODO CHANGE BARCODE IMAGE WITH VALID IMAGE
  const canvas = document.createElement("canvas");
  Jsbarcode(canvas, code);
  //const barcode = canvas.toDataURL();
  const qrcode = QRCode.toDataURL(code);
  return (
    <>
      <View style={styles.body}>
        <View style={styles.grayBox}>
          {eventName ? (
            <Text style={styles.boldText}>Evento {eventName}</Text>
          ) : (
            <Text style={styles.boldText}>Prenotazione visita al museo</Text>
          )}
          <Text>
            il / <i style={styles.italicText}>on</i>{" "}
            <b style={styles.boldText}>{data}</b>
          </Text>
          {eventName ? (
            <Text>
              dalle ore{" "}
              <b style={styles.boldText}>{moment(oraInizio).format("HH:mm")}</b>{" "}
              alle ore{" "}
              <b style={styles.boldText}>{moment(oraFine).format("HH:mm")}</b> /{" "}
              <i style={styles.italicText}>
                from{" "}
                <b style={styles.boldText}>
                  {moment(oraInizio).format("h:mm a")}
                </b>{" "}
                to{" "}
                <b style={styles.boldText}>
                  {moment(oraFine).format("h:mm a")}
                </b>
              </i>
            </Text>
          ) : (
            <Text>
              alle ore{" "}
              <b style={styles.boldText}>{moment(oraInizio).format("HH:mm")}</b>{" "}
              /{" "}
              <i style={styles.italicText}>
                at{" "}
                <b style={styles.boldText}>
                  {moment(oraInizio).format("h:mm a")}
                </b>
              </i>
            </Text>
          )}
          <Text>
            presso / <i style={styles.italicText}>at</i>{" "}
            <b style={styles.boldText}>{luogoEvento || museumName}</b>
          </Text>
          <View style={styles.break} />
          <Text>
            Registrazione a nome /{" "}
            <i style={styles.italicText}>Reservation for</i>
          </Text>
          <Text>
            <b style={styles.boldText}>{username}</b>
          </Text>
          <Text>per</Text>
          <Text>
            <b style={styles.boldText}>{numPartecipanti}</b> partecipanti.
          </Text>
          <View style={styles.break} />
          {typeTicket ? (
            <Text>
              Tipo biglietto: <b style={styles.boldText}>{typeTicket}</b>
            </Text>
          ) : null}
          {paymentMethod ? (
            <Text>
              Metodo di pagamento:{" "}
              <b style={styles.boldText}>{paymentMethod}</b>
            </Text>
          ) : null}
          {price ? (
            <Text>
              Prezzo: <b style={styles.boldText}>{price} €</b>
            </Text>
          ) : null}
          <View style={styles.break} />
          <Text>Codice prenotazione: {code}</Text>
          <View style={styles.break_2} />
          <Image style={styles.qrcode} src={qrcode} />
          <View style={styles.break_2} />
          <Text style={{ textAlign: "left", fontSize: "12px" }}>
            <b style={styles.boldText}>
              Informazioni /{" "}
              <i style={styles.italicText}> Additional information</i>
            </b>
          </Text>
          <Text style={{ textAlign: "left", fontSize: "12px" }}>
            {infoEvento}{" "}
          </Text>
          <View style={styles.break} />
          <Text style={{ textAlign: "left", fontSize: "10px" }}>
            Per cancellare la prenotazione la preghiamo di contattarci al numero{" "}
            {telMuseo} /{" "}
          </Text>
          <Text style={{ textAlign: "left", fontSize: "10px" }}>
            <i>To cancel the reservation please call {telMuseo}</i>
          </Text>
        </View>
        <View style={styles.footerBox}>
          <Text>
            Hai ricevuto questa email in seguito alla prenotazione di un evento
            presso un museo che utilizza{" "}
            <a href="https://www.rnb4culture.com/emma">EMMA</a> come sistema di
            gestione. I tuoi dati sono trattati in maniera conforme a quanto
            previsto dal Regolamento UE 2016/679 (GDPR) e dalla normativa
            applicabile in materia di protezione dei dati personali.
          </Text>
          <Text>
            Responsabile del trattamento dei dati: RnB4Culture, Piazza Federico
            II 3, 60035 Jesi (AN). Partita Iva 02834720423. Per maggiori
            informazioni{" "}
            <a href="https://www.rnb4culture.com/emma/privacypolicy.html">
              Privacy Policy
            </a>{" "}
          </Text>
          <View style={styles.break} />
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text>
              <b>
                {museumName +
                  " | " +
                  emailMuseo +
                  " | " +
                  telMuseo +
                  " | " +
                  addressMuseo}
              </b>
            </Text>
          </View>
          <View style={styles.break} />
          <View
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text>
              <a href="mailto:info@rnb4culture.com">info@rnb4culture.com </a> -{" "}
              <a href="https://www.rnb4culture.com/">rnb4culture.com</a>
            </Text>
          </View>
          <View style={styles.break} />
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Image style={styles.logo} src={logoMuseo} />
            <Image style={styles.logo} src={logo_emma} />
            <Image style={styles.logo} src={logo_rnb} />
          </View>
        </View>
      </View>
    </>
  );
}
